import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="w-full bg-background-100" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          <div className="flex-1">
            <Link to="/" className="inline-block cursor-pointer" aria-label="韩漫漫画网">
              <span className="text-xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫漫画网
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 max-w-md">
              韩漫漫画网是热门漫画在线阅读平台，实现全网韩漫最快更新，涵盖韩漫大全，内容多样，加载快捷，为您提供极速阅读服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">全部漫画</Link>
              <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">恋爱漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">动作漫画</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">奇幻漫画</Link>
              <Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">悬疑漫画</Link>
              <Link to="/category/comedy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">搞笑漫画</Link>
              <Link to="/category/drama" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">剧情漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">联系我们</h4>
            <div className="flex flex-col gap-2">
              <a href="mailto:contact@hanman.com" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-mail-line mr-1"></i>contact@hanman.com
              </a>
              <span className="text-sm text-foreground-600 whitespace-nowrap">
                <i className="ri-phone-line mr-1"></i>400-888-9999
              </span>
              <span className="text-sm text-foreground-600 whitespace-nowrap">
                <i className="ri-map-pin-line mr-1"></i>北京市朝阳区
              </span>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫漫画网. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;